(function () {
  const block = {
    $blocks: document.querySelectorAll('.practice_areas'),
    init() {
      if (this.$blocks.length) {
        PubSub.publish('embla.init', {
          name: 'practice-areas-carousel',
          $els: this.$blocks,
          options: {
            loop: true
          },
          plugins: [
            EmblaCarouselAutoScroll({
              speed: 0.7,
              playOnInit: false,
              startDelay: 0
            })
          ]
        });
      }
    }
  };

  block.init();
})();
